export default __webpack_public_path__ + "static/media/app-ftz-03.62ab6dad.png";